// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-61bcc8a6]{border:1px solid #ccc}.editor .editor-toolbar[data-v-61bcc8a6]{border-bottom:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
